export const usePostData = () => {
    const postData = async ({
        url,
        apiKey,
        payload,
        method = 'post',
        returnType = 'json',
        db = 'postgres'
    }: {
        url: string
        apiKey?: string
        payload?: object
        method?: 'post' | 'put' | 'delete'
        returnType?: 'json' | 'blob'
        db?: 'postgres' | 'both' | 'fauna'
    }) => {
        const postUrl = url
        const headers: Record<string, string> = { 'content-type': 'application/json' }
        if (apiKey) {
            headers['x-api-key'] = apiKey
            headers['x-jwt'] = apiKey
            headers['x-token'] = apiKey
        }
        if (db) {
            headers['x-db'] = db
        }
        const response = await fetch(postUrl, {
            method,
            headers,
            body: JSON.stringify(payload)
        })
        if (!response.ok) {
            throw new Error('Network response was not ok')
        }
        if (returnType === 'json') {
            return await response.json()
        } else if (returnType === 'blob') {
            return await response.blob()
        }
    }
    return postData
}

export default usePostData
